export default [
  {
    label: 'locale'
  }
]
